export default __webpack_public_path__ + "static/media/card.1fade92a.svg";